import React from "react";
import { useAuth } from "../../../hooks/pages/useAuth";

import {
  getProjectImage,
  getStatusDetails,
} from "../../../utils/admin/projectUtils";

const ProjectTable = ({ projects, onEdit, onDelete }) => {
  const { user: currentUser } = useAuth();

  return (
    <div className="mt-4">
      {/* Desktop */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full table-auto border border-gray-300 dark:border-gray-700 text-sm">
          <thead className="bg-gray-100 dark:bg-gray-800">
            <tr className="text-gray-900 dark:text-gray-100">
              <th className="border p-2">ID</th>
              <th className="border p-2">Ảnh</th>
              <th className="border p-2">Tên dự án</th>
              <th className="border p-2">Chủ đầu tư</th>
              <th className="border p-2">Địa điểm</th>
              <th className="border p-2">Link dự án</th>
              <th className="border p-2">Trạng thái</th>
              <th className="border p-2">Người tạo</th>
              <th className="border p-2">Hành động</th>
            </tr>
          </thead>

          <tbody className="bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
            {projects.length > 0 ? (
              projects.map((project) => {
                const imgSrc = getProjectImage(project.image);
                const statusInfo = getStatusDetails(project.status);

                return (
                  <tr
                    key={project.id}
                    className="hover:bg-gray-50 dark:hover:bg-gray-800"
                  >
                    <td className="border p-2 text-center">{project.id}</td>

                    <td className="border p-2 text-center">
                      <img
                        src={imgSrc}
                        alt={project.name}
                        className="w-full h-40 object-cover rounded"
                        onError={(e) => {
                          e.target.src = "/placeholder.png";
                        }}
                      />
                    </td>

                    <td className="border p-2 font-medium max-w-[200px] truncate">
                      {project.name}
                    </td>

                    <td className="border p-2">
                      {project.developer || "-"}
                    </td>

                    <td className="border p-2">
                      {project.location || "-"}
                    </td>

                    <td className="border p-2">
                      {project.url ? (
                        <a
                          href={project.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline"
                        >
                          Link
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td className="border p-2">
                      <span
                        className={`inline-flex items-center gap-1 px-2 py-1 rounded text-white text-xs font-medium ${statusInfo.bgColor}`}
                      >
                        {statusInfo.icon}
                        {statusInfo.label}
                      </span>
                    </td>

                    <td className="border p-2">
                      {project.user?.name || "-"}
                    </td>

                    <td className="border p-2 text-center space-x-2">
                      {currentUser?.role === "admin" && (
                        <>
                          <button
                            onClick={() => onEdit(project)}
                            className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded"
                          >
                            Sửa
                          </button>

                          <button
                            onClick={() => onDelete(project.id)}
                            className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded"
                          >
                            Xoá
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan="9"
                  className="text-center py-4 text-gray-500"
                >
                  Không có dữ liệu
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile */}
      <div className="lg:hidden space-y-4">
        {projects.map((project) => {
          const imgSrc = getProjectImage(project.image);
          const statusInfo = getStatusDetails(project.status);

          return (
            <div
              key={project.id}
              className="border rounded p-4 bg-white dark:bg-gray-900 shadow-sm text-sm text-gray-900 dark:text-gray-100"
            >
              <img
                src={imgSrc}
                alt={project.name}
                className="w-full h-40 object-cover rounded mb-3"
                onError={(e) => {
                  e.target.src = "/placeholder.png";
                }}
              />

              <div>
                <strong>Tên dự án:</strong> {project.name}
              </div>

              <div>
                <strong>Chủ đầu tư:</strong>{" "}
                {project.developer || "-"}
              </div>

              <div>
                <strong>Địa điểm:</strong>{" "}
                {project.location || "-"}
              </div>

              <div>
                <strong>Link dự án:</strong>{" "}
                {project.url ? (
                  <a
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Xem
                  </a>
                ) : (
                  "-"
                )}
              </div>

              <div className="mt-2">
                <strong>Trạng thái:</strong>{" "}
                <span
                  className={`inline-flex items-center gap-1 px-2 py-1 rounded text-white text-xs font-medium ${statusInfo.bgColor}`}
                >
                  {statusInfo.icon}
                  {statusInfo.label}
                </span>
              </div>

              <div className="mt-1">
                <strong>Người tạo:</strong>{" "}
                {project.user?.name || "-"}
              </div>

              {currentUser?.role === "admin" && (
                <div className="mt-3 flex gap-2">
                  <button
                    onClick={() => onEdit(project)}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                  >
                    Sửa
                  </button>

                  <button
                    onClick={() => onDelete(project.id)}
                    className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                  >
                    Xoá
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectTable;